export default function Radio({ items = [] }) {
  return (
    <section
      id="radio"
      data-testid="radio-section"
      className="relative bg-[#EFEFEA] text-[#1A1A1A] py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-[#1A1A1A]" />
            <span className="font-mono-overline">03 — Radio & audio</span>
          </div>
          <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05] max-w-3xl">
            On the <em className="text-[#A68661]">airwaves</em>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {items.map((r, idx) => (
            <a
              key={r.id}
              data-testid={`radio-${r.id}`}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col p-8 md:p-10 border border-[rgba(26,26,26,0.12)] bg-[#F7F7F5] hover:border-[#A68661] transition-all duration-500 hover:translate-y-[-2px]"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full border border-[#1A1A1A] flex items-center justify-center group-hover:bg-[#A68661] group-hover:border-[#A68661] group-hover:text-white transition-all">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <path d="M3 12a9 9 0 0 1 18 0" />
                      <path d="M3 12v3a2 2 0 0 0 2 2h2v-7H5a2 2 0 0 0-2 2z" />
                      <path d="M21 12v3a2 2 0 0 1-2 2h-2v-7h2a2 2 0 0 1 2 2z" />
                    </svg>
                  </div>
                  <div>
                    <div className="font-mono-overline text-[#A68661]">CBC Radio</div>
                    <div className="font-serif-display text-lg italic">{r.show}</div>
                  </div>
                </div>
                <span className="font-mono-overline text-[#1A1A1A]/40">{String(idx + 1).padStart(2, "0")}</span>
              </div>

              <h3 className="font-serif-display text-2xl md:text-3xl leading-[1.15] group-hover:text-[#A68661] transition-colors mb-3">
                {r.title}
              </h3>
              <p className="text-[#1A1A1A]/75 text-base leading-relaxed mb-6">{r.description}</p>

              <div className="mt-auto pt-6 border-t border-[rgba(26,26,26,0.12)] flex items-center justify-between">
                <span className="edit-link">
                  Listen on CBC
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M7 17L17 7M9 7h8v8" />
                  </svg>
                </span>
                <span className="font-mono-overline text-[#1A1A1A]/50">{r.date}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
